import classNames from "classnames";
import React from "react";
import { useI18n } from "../lib/i18n/i18n_provider";
import { TextColor, TextWeight } from "./text";
import { useTheme } from "./theme";

interface TextLinkProps {
  external?: boolean;
  children: React.ReactNode;
  onPress?: () => void;
  href?: string;
  weight?: TextWeight;
  color?: TextColor;
  disable?: boolean;
  textDecoration?: string;
  className?: string;
}

export function TextLink(props: TextLinkProps) {
  const {
    onPress,
    href,
    external,
    children,
    weight,
    color = "link",
    disable = false,
    textDecoration = "underline",
    className,
  } = props;
  const theme = useTheme();
  const { locale } = useI18n();

  return (
    <a
      className={classNames(
        "text",
        "text-link",
        disable ? "text-color-muted disable" : color && `text-color-${color}`,
        weight && `text-weight-${weight}`,
        `text-${locale.baseLanguageTag}`,
        className
      )}
      onClick={onPress}
      href={href}
      target={external ? "_blank" : undefined}
      style={{ fontFamily: theme.fontFamilyBody, textDecoration }}
      rel={external ? "noopener" : undefined}
    >
      {children}
    </a>
  );
}
